import ColumnsLayout from 'components/contentLayouts/ColumnsLayout';
import Paragraph from 'components/text/Paragraph';
import PropTypes from 'prop-types';
import React from 'react';
import { TextLinkWysisyg } from 'components/text/TextLink';
import Wysiwyg from 'libs/wordpress/components/Wysiwyg';
import styled from 'libs/styled';
import { wysiwygProp } from 'utils/proptypes/modules/textProps';

const Div = styled('div')``;

const Wrapper = styled('div', { shouldForwardProp: prop => ['fullWidth'].indexOf(prop) === -1 })`
    ${({ fullWidth }) =>
        !fullWidth &&
        `
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: center;
    `}
`;

/**
 * Display a quote with the authors name beneath.
 *
 * @param {string} author - Name of the author.
 * @param {bool} fullWidth - Adjusts the appearance for full screen.
 * @param {array} quote - wysiwyg displayed with quote styling.
 */

const Quote = ({ author, fullWidth = true, quote }) => (
    <Wrapper fullWidth={fullWidth}>
        <ColumnsLayout
            blocks={[
                <Div
                    as="blockquote"
                    key="quote"
                    m="0"
                    order={fullWidth ? [1, null, 2] : 1}
                    size={fullWidth ? [12, null, 8, 6] : 12}
                >
                    <Wysiwyg
                        data={quote}
                        tagComponents={{ url: TextLinkWysisyg }}
                        textComponent={props => <Paragraph fontStyle="italic" size="xl" {...props} />}
                    />
                </Div>,
                <Div key="author" order={fullWidth ? [2, null, 1] : 1} size={fullWidth ? [12, null, 4, 6] : 12}>
                    <Paragraph>{author}</Paragraph>
                </Div>,
            ]}
            gutterHeight={32}
        />
    </Wrapper>
);

Quote.propTypes = {
    author: PropTypes.string,
    fullWidth: PropTypes.bool,
    quote: wysiwygProp,
};

export default Quote;
